/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PromotionCampaignAwardConfig } from './PromotionCampaignAwardConfig';
import {
    PromotionCampaignAwardConfigFromJSON,
    PromotionCampaignAwardConfigFromJSONTyped,
    PromotionCampaignAwardConfigToJSON,
} from './PromotionCampaignAwardConfig';
import type { PromotionRewardCategory } from './PromotionRewardCategory';
import {
    PromotionRewardCategoryFromJSON,
    PromotionRewardCategoryFromJSONTyped,
    PromotionRewardCategoryToJSON,
} from './PromotionRewardCategory';

/**
 * Award configuration for a campaign
 * @export
 * @interface PromotionCampaignAward
 */
export interface PromotionCampaignAward {
    /**
     * 
     * @type {PromotionCampaignAwardConfig}
     * @memberof PromotionCampaignAward
     */
    config: PromotionCampaignAwardConfig;
    /**
     * User-facing description of the reward (e.g., "500 entries", "$5.00")
     * @type {string}
     * @memberof PromotionCampaignAward
     */
    description: string;
    /**
     * 
     * @type {PromotionRewardCategory}
     * @memberof PromotionCampaignAward
     */
    type: PromotionRewardCategory;
}



/**
 * Check if a given object implements the PromotionCampaignAward interface.
 */
export function instanceOfPromotionCampaignAward(value: object): value is PromotionCampaignAward {
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PromotionCampaignAwardFromJSON(json: any): PromotionCampaignAward {
    return PromotionCampaignAwardFromJSONTyped(json, false);
}

export function PromotionCampaignAwardFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionCampaignAward {
    if (json == null) {
        return json;
    }
    return {
        
        'config': PromotionCampaignAwardConfigFromJSON(json['config']),
        'description': json['description'],
        'type': PromotionRewardCategoryFromJSON(json['type']),
    };
}

export function PromotionCampaignAwardToJSON(value?: PromotionCampaignAward | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'config': PromotionCampaignAwardConfigToJSON(value['config']),
        'description': value['description'],
        'type': PromotionRewardCategoryToJSON(value['type']),
    };
}

